








import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";
import { NumberSelector } from "../selectors";
import { PageNoEditableMixin } from "./mixins";

@Component({
  components: {
    NumberSelector,
  },
})
export default class PageDropDownSelector extends Mixins(PageNoEditableMixin, ModelEditableMixin) {
}
